// AuraMax V1 — mock/demo data. Easily replaceable with a real API later.
export const LOGO = "/auramax-logo.png";

// Portraits / avatars
const P = {
  togi: "https://images.unsplash.com/photo-1783305785797-9e737663fe39?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
  creator: "https://images.unsplash.com/photo-1769636929132-e4e7b50cfac0?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
  artist: "https://images.unsplash.com/photo-1790341232745-f9bdd7dd3f33?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
  founder: "https://images.unsplash.com/photo-1558959355-d9922ff0b767?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
  streamer: "https://images.unsplash.com/photo-1606242629702-5dd5ff63e84a?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
  builder: "https://images.unsplash.com/photo-1762341120156-4a8303067873?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
  dancer: "https://images.unsplash.com/photo-1784330687520-feb4ab44e5dd?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
};

// Media
const M = {
  cityNight: "https://images.unsplash.com/photo-1616400557946-8a556f8809d7?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  skate: "https://images.unsplash.com/photo-1631297659547-c9623fef39ee?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  neonStreet: "https://images.unsplash.com/photo-1645544311737-24c0f91685e3?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  rain: "https://images.unsplash.com/photo-1772801082446-00b02931c97b?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  mountains: "https://images.unsplash.com/photo-1604223172843-9541457ba7e4?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  mountains2: "https://images.unsplash.com/photo-1604223190546-a43e4c7f29d7?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  studio: "https://images.unsplash.com/photo-1559732277-7453b141e3a1?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  studio2: "https://images.unsplash.com/photo-1563330232-57114bb0823c?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  carWhite: "https://images.unsplash.com/photo-1673170717377-93fd50d26689?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  carYellow: "https://images.unsplash.com/photo-1716687504751-6788a860cbfe?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  gym: "https://images.unsplash.com/photo-1669322779651-5ca89652492e?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  gym2: "https://images.unsplash.com/photo-1556817411-31ae72fa3ea0?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  setup: "https://images.unsplash.com/photo-1675301909821-2541a0db13ab?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  setup2: "https://images.unsplash.com/photo-1642791401714-a0d4e02d4bb6?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  desk: "https://images.unsplash.com/photo-1562071707-7249ab429b2a?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
};

export const MEDIA = M;
export const PORTRAITS = P;

export const CURRENT_USER = {
  name: "You",
  username: "yournewaura",
  avatar: P.builder,
  aura: "0",
};

export const CREATORS = {
  togi: {
    id: "togi", name: "Togi", username: "togi", verified: false,
    avatar: P.togi, banner: M.cityNight,
    bio: "building in public • prototype profile • max your aura ⚡",
    location: "Internet", link: "auramax.app/togi",
    followers: "128K", following: "284", aura: "4.8M",
    coin: { status: "not_launched" },
  },
  creator: {
    id: "creator", name: "Nova", username: "creator", verified: false,
    avatar: P.creator, banner: M.neonStreet,
    bio: "content • culture • community", location: "LA",
    followers: "94K", following: "150", aura: "2.1M",
  },
  artist: {
    id: "artist", name: "Kade", username: "artist", verified: false,
    avatar: P.artist, banner: M.studio,
    bio: "sounds & visuals", location: "ATL",
    followers: "61K", following: "210", aura: "1.6M",
  },
  founder: {
    id: "founder", name: "Rue", username: "founder", verified: false,
    avatar: P.founder, banner: M.desk,
    bio: "0 → 1 • building things", location: "NYC",
    followers: "48K", following: "302", aura: "1.2M",
  },
  streamer: {
    id: "streamer", name: "Zeno", username: "streamer", verified: false,
    avatar: P.streamer, banner: M.setup,
    bio: "live most nights • aura live", location: "Online",
    followers: "212K", following: "88", aura: "5.4M",
  },
  builder: {
    id: "builder", name: "Sol", username: "builder", verified: false,
    avatar: P.builder, banner: M.mountains,
    bio: "shipping • traveling • growing", location: "Lisbon",
    followers: "37K", following: "190", aura: "980K",
  },
};

export const FEED = [
  {
    id: "v1", creator: CREATORS.streamer, poster: M.neonStreet,
    caption: "late night city stream hit different tonight 🌆",
    tags: ["#nightcity", "#auramax", "#live"],
    audio: "original sound — Zeno", likes: 42500, comments: 1243, shares: 3820, saved: 892,
  },
  {
    id: "v2", creator: CREATORS.builder, poster: M.mountains,
    caption: "different kind of therapy. shot this on the ridge at sunrise ⛰️",
    tags: ["#travel", "#aura", "#sunrise"],
    audio: "ambient — slow mornings", likes: 18900, comments: 840, shares: 1120, saved: 640,
  },
  {
    id: "v3", creator: CREATORS.artist, poster: M.studio2,
    caption: "cooking something in the lab. drop coming soon 🎧",
    tags: ["#music", "#studio", "#newmusic"],
    audio: "unreleased — Kade", likes: 27400, comments: 1590, shares: 2210, saved: 1310,
  },
  {
    id: "v4", creator: CREATORS.streamer, poster: M.setup,
    caption: "setup tour 2026: the whole battlestation ⚡️",
    tags: ["#gaming", "#setup", "#tech"],
    audio: "original sound — Zeno", likes: 33100, comments: 990, shares: 1740, saved: 2040,
  },
  {
    id: "v5", creator: CREATORS.creator, poster: M.rain,
    caption: "rainy walks + a lil aura check. how we feeling 💧",
    tags: ["#lifestyle", "#auracheck"],
    audio: "lofi — after hours", likes: 51200, comments: 2110, shares: 4400, saved: 1880,
  },
];

export const TRENDING = [
  { tag: "#AURAMAX", posts: "1.3M posts" },
  { tag: "#MaxYourAura", posts: "843K posts" },
  { tag: "#AuraCheck", posts: "631K posts" },
  { tag: "#FreshAura", posts: "420K posts" },
  { tag: "#GoLive", posts: "381K posts" },
];

export const SUGGESTED = [
  CREATORS.creator, CREATORS.artist, CREATORS.founder, CREATORS.builder,
];

export const LEADERBOARD_WINDOWS = ["Now", "Today", "This Week"];

// Fresh Aura leaderboard — mock momentum only (Aura is a social metric, not money)
export const LEADERBOARD = [
  { creator: CREATORS.streamer, aura: "5.4M", cat: "Gaming",
    windows: { Now: { gain: 3120, pct: "+2.4%" }, Today: { gain: 128400, pct: "+18.2%" }, "This Week": { gain: 742000, pct: "+31.6%" } } },
  { creator: CREATORS.togi, aura: "4.8M", cat: "Lifestyle",
    windows: { Now: { gain: 2870, pct: "+2.1%" }, Today: { gain: 96200, pct: "+14.7%" }, "This Week": { gain: 610000, pct: "+27.4%" } } },
  { creator: CREATORS.creator, aura: "2.1M", cat: "Lifestyle",
    windows: { Now: { gain: 2610, pct: "+3.0%" }, Today: { gain: 74300, pct: "+21.5%" }, "This Week": { gain: 388000, pct: "+34.9%" } } },
  { creator: CREATORS.artist, aura: "1.6M", cat: "Music",
    windows: { Now: { gain: 1740, pct: "+1.8%" }, Today: { gain: 61200, pct: "+12.1%" }, "This Week": { gain: 291000, pct: "+22.0%" } } },
  { creator: CREATORS.founder, aura: "1.2M", cat: "Business",
    windows: { Now: { gain: 1180, pct: "+1.4%" }, Today: { gain: 40900, pct: "+9.8%" }, "This Week": { gain: 204000, pct: "+18.5%" } } },
  { creator: CREATORS.builder, aura: "980K", cat: "Travel",
    windows: { Now: { gain: 940, pct: "+1.1%" }, Today: { gain: 31200, pct: "+8.4%" }, "This Week": { gain: 168000, pct: "+20.7%" } } },
];

export const LIVE_NOW = [
  {
    id: "l1", creator: CREATORS.streamer, cover: M.setup,
    title: "night grind — building the aura", viewers: 4200, category: "Gaming",
  },
  {
    id: "l2", creator: CREATORS.artist, cover: M.studio,
    title: "studio session — making a beat live", viewers: 1870, category: "Music",
  },
  {
    id: "l3", creator: CREATORS.creator, cover: M.neonStreet,
    title: "irl walk through the city 🌆", viewers: 3120, category: "IRL",
  },
  {
    id: "l4", creator: CREATORS.founder, cover: M.desk,
    title: "startup q&a — ask me anything", viewers: 940, category: "Business",
  },
  {
    id: "l5", creator: CREATORS.builder, cover: M.mountains2,
    title: "morning hike + coffee chat", viewers: 1260, category: "Travel",
  },
];

export const LIVE_CHAT = [
  { user: "jakee", text: "this aura crazy" },
  { user: "sofiee", text: "🔥🔥🔥" },
  { user: "user123", text: "W" },
  { user: "dylan", text: "auramaxxing fr" },
  { user: "matt", text: "bro is up" },
  { user: "lexi", text: "this live different" },
  { user: "tony", text: "put em on 🙏" },
  { user: "ryan", text: "aura up" },
  { user: "chris", text: "goated stream" },
  { user: "bella", text: "hard af" },
];

export const EXPLORE_CATEGORIES = [
  "Trending", "Creators", "Music", "Lifestyle", "Business",
  "Fitness", "Gaming", "Cars", "Fashion", "Live",
];

export const EXPLORE_GRID = [
  { id: "e1", media: M.neonStreet, views: "1.4M", cat: "Lifestyle", creator: CREATORS.creator },
  { id: "e2", media: M.carWhite, views: "892K", cat: "Cars", creator: CREATORS.founder },
  { id: "e3", media: M.gym, views: "645K", cat: "Fitness", creator: CREATORS.builder },
  { id: "e4", media: M.studio, views: "1.2M", cat: "Music", creator: CREATORS.artist },
  { id: "e5", media: M.mountains, views: "981K", cat: "Lifestyle", creator: CREATORS.builder },
  { id: "e6", media: M.setup, views: "712K", cat: "Gaming", creator: CREATORS.streamer },
  { id: "e7", media: M.carYellow, views: "1.1M", cat: "Cars", creator: CREATORS.founder },
  { id: "e8", media: M.rain, views: "834K", cat: "Fashion", creator: CREATORS.creator },
  { id: "e9", media: M.gym2, views: "560K", cat: "Fitness", creator: CREATORS.builder },
  { id: "e10", media: M.skate, views: "1.7M", cat: "Lifestyle", creator: CREATORS.streamer },
  { id: "e11", media: M.studio2, views: "430K", cat: "Music", creator: CREATORS.artist },
  { id: "e12", media: M.mountains2, views: "1.0M", cat: "Travel", creator: CREATORS.builder },
];

export const INTERESTS = [
  "Music", "Business", "Lifestyle", "Fitness", "Gaming", "Cars",
  "Fashion", "Art", "Comedy", "Streaming", "Entrepreneurship", "Travel",
];

export const NOTIFICATIONS = [
  { id: "n1", type: "aura", icon: "zap", text: "+250 Aura — your post is moving.", time: "2m", unread: true },
  { id: "n2", type: "follows", icon: "user", text: "Nova started following you.", time: "18m", unread: true, creator: CREATORS.creator },
  { id: "n3", type: "aura", icon: "trending", text: "Your video passed 10K views.", time: "1h", unread: true },
  { id: "n4", type: "live", icon: "live", text: "Togi went live — night city stream.", time: "2h", unread: false, creator: CREATORS.togi },
  { id: "n5", type: "mentions", icon: "at", text: "3 people mentioned you in comments.", time: "3h", unread: false },
  { id: "n6", type: "follows", icon: "user", text: "Zeno started following you.", time: "5h", unread: false, creator: CREATORS.streamer },
  { id: "n7", type: "aura", icon: "up", text: "Your Aura is up today ↑ +1,120", time: "8h", unread: false },
  { id: "n8", type: "mentions", icon: "at", text: "Kade replied to your comment.", time: "1d", unread: false, creator: CREATORS.artist },
];

export const NOTIF_TABS = ["All", "Mentions", "Follows", "Aura", "Live"];

export const CONVERSATIONS = [
  { id: "c1", creator: CREATORS.creator, last: "sent you a photo", time: "2h", unread: 3, preview: [
    { me: false, text: "yo the last post was insane 🔥" },
    { me: true, text: "appreciate it fr 🙏" },
    { me: false, text: "we gotta collab soon" },
  ] },
  { id: "c2", creator: CREATORS.streamer, last: "let's collab this week", time: "4h", unread: 1, preview: [
    { me: false, text: "you live tonight?" },
    { me: true, text: "maybe around 9" },
    { me: false, text: "let's collab this week" },
  ] },
  { id: "c3", creator: CREATORS.artist, last: "this is a wrap 🎧", time: "7h", unread: 0, preview: [
    { me: true, text: "how's the track coming" },
    { me: false, text: "this is a wrap 🎧" },
  ] },
  { id: "c4", creator: CREATORS.founder, last: "seen — 1d", time: "1d", unread: 0, preview: [
    { me: false, text: "loved the breakdown you posted" },
    { me: true, text: "thank you! more soon" },
  ] },
  { id: "c5", creator: CREATORS.builder, last: "shared a link", time: "2d", unread: 0, preview: [
    { me: false, text: "check this out" },
  ] },
];

// Creator Coin DEMO — clearly fictional, prototype UI only
export const COIN_DEMO = {
  name: "Aura Creator Coin",
  ticker: "$DEMO",
  creator: "Creator Coin Demo",
  price: "0.0421",
  change: "+12.8%",
  marketCap: "$42.1M",
  holders: "12.4K",
  volume: "$8.6M",
  about:
    "This is a non-functional prototype interface used only to evaluate how a personal Creator Coin page could feel inside AuraMax. It is not attached to any real person and no trading occurs.",
  chart: [12, 14, 13, 16, 15, 19, 18, 22, 21, 26, 24, 31, 29, 34, 33, 40, 44, 41, 48, 52, 49, 58, 61, 67],
};

export const SETTINGS_SECTIONS = [
  { key: "account", label: "Account & Security", desc: "Email, password and sign-in methods" },
  { key: "profile", label: "Profile", desc: "Edit your public identity" },
  { key: "privacy", label: "Privacy", desc: "Who can see and reach you" },
  { key: "notifications", label: "Notifications", desc: "Choose what pings you" },
  { key: "content", label: "Content Preferences", desc: "Tune your For You feed" },
  { key: "verification", label: "Identity Verification", desc: "Establish who you are" },
  { key: "connected", label: "Connected Accounts", desc: "Link other platforms" },
  { key: "appearance", label: "Appearance", desc: "Theme and display" },
  { key: "security", label: "Security", desc: "Password and sessions" },
  { key: "help", label: "Help", desc: "Get support" },
  { key: "about", label: "About AuraMax", desc: "Version and info" },
];

export function auraForAction(action) {
  return { like: 10, comment: 20, share: 100, save: 30, follow: 100, post: 10, gift: 500 }[action] || 10;
}

export function fmt(n) {
  if (n >= 1_000_000) return (n / 1_000_000).toFixed(1).replace(/\.0$/, "") + "M";
  if (n >= 1_000) return (n / 1_000).toFixed(1).replace(/\.0$/, "") + "K";
  return String(n);
}
